'use strict';

// マイページ（/me）の成績カード設定。枚数ラジオ（4/6）に連動して選択数を制御する
//
// 方式は「拒否方式」:
//   - 上限に達した状態での追加チェックは受け付けず、警告で「先に外してください」と促す
//   - 既存の選択を自動で外すのは「枚数を 6→4 に減らしたとき」だけ（一覧の下から外す）
//   - チェックボックスは disabled にしない（同画面の「焼き鳥記録」のPro限定グレーアウトと
//     誤読されるため。本機能にPro制限はない）
//
// デフォルトキーと文言はJSにハードコードせず、HAML側の data 属性から受け取る
// （正本は User::DEFAULT_STAT_CARD_KEYS / config/locales の users.show.stat_cards.*）

$(document).on('turbolinks:load', function() {
  var $checks = $('.js-stat-card-check');
  if ($checks.length === 0) return;

  var $section = $checks.first().closest('.setting-item');
  var defaultKeys = $section.data('default-keys') || [];
  var messages = $section.data('i18n') || {};
  var $warning = $('.js-stat-card-warning');
  var textTimer = null;    // ライブリージョン再発火用（同じ文言でも読み上げさせる）
  var restoreTimer = null; // 一時的な警告を定常状態へ戻す用

  function currentMax() {
    return parseInt($('.js-stat-card-count-radio:checked').val(), 10);
  }

  function selectedCount() {
    return $checks.filter(':checked').length;
  }

  function clearTimers() {
    if (textTimer) { window.clearTimeout(textTimer); textTimer = null; }
    if (restoreTimer) { window.clearTimeout(restoreTimer); restoreTimer = null; }
  }

  // 一度空にしてから入れ直す。テキストが変化しないと aria-live が発火しないため
  function showWarning(text) {
    clearTimers();
    $warning.removeClass('d-none').text('');
    textTimer = window.setTimeout(function() { $warning.text(text); }, 50);
  }

  function updateCounter() {
    $('.js-stat-card-selected').text(selectedCount());
    $('.js-stat-card-max').text(currentMax());
  }

  // 定常状態: 選択数と上限が一致していなければ（不足・超過とも）警告を出し続ける
  function updateState() {
    updateCounter();
    if (selectedCount() === currentMax()) {
      clearTimers();
      $warning.addClass('d-none').text('');
    } else {
      showWarning((messages.countMismatch || '').replace('%{num}', currentMax()));
    }
  }

  // 一覧の下から超過分を外す（上位のデフォルト項目を残すため）。戻り値は外した件数
  function trimFromBottom(max) {
    var $checked = $checks.filter(':checked');
    var over = $checked.length - max;
    if (over <= 0) return 0;
    $checked.slice(-over).prop('checked', false);
    return over;
  }

  // 枚数を減らしたときだけ自動解除が起きる。件数を通知して4秒後に定常状態へ戻す
  $('.js-stat-card-count-radio').on('change', function() {
    var removed = trimFromBottom(currentMax());
    if (removed === 0) { updateState(); return; }
    updateCounter();
    showWarning((messages.countReduced || '').replace('%{num}', removed));
    restoreTimer = window.setTimeout(updateState, 4000);
  });

  // 上限に達した状態での追加チェックは受け付けない（既存の選択は外さない）
  $checks.on('change', function() {
    if (this.checked && selectedCount() > currentMax()) {
      $(this).prop('checked', false);
      showWarning((messages.limitReached || '').replace('%{num}', currentMax()));
      restoreTimer = window.setTimeout(updateState, 4000);
      return;
    }
    updateState();
  });

  $('.js-stat-card-reset').on('click', function() {
    $('#stat_card_count_4').prop('checked', true);
    $checks.each(function() {
      $(this).prop('checked', defaultKeys.indexOf($(this).val()) !== -1);
    });
    updateState();
  });

  updateState();
});
